import {
  Row,
  Col,
  ContactInfo,
  Card,
  Avatar,
  Text,
  Separator,
  CardBody,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import Sidebar from "../../components/Sidebar/Sidebar"

import { getAddress } from "../../functions/getAddress"
import { PhoneNumber } from "../../Shared"
import { useSelectedProfile } from "../../app/hooks"

const Profile = () => {
  const { t } = useTranslation()
  const profile = useSelectedProfile()

  return (
    <Row className="mt-2" style={{ marginBottom: "3.5rem" }}>
      <Col md={3}>
        <Sidebar />
      </Col>
      <Col md={9}>
        <Card style={{ backgroundColor: "#129df9", padding: "3.5rem" }}>
          <Avatar
            size={Avatar.SIZE.SIZE_96}
            className="d-flex justify-content-center m-auto"
            icon={Avatar.ICON.USER}
          />
          <Text
            style={{
              color: "white",
              fontWeight: "bold",
              fontSize: "1.3rem",
              marginTop: "2rem",
              textAlign: "center",
            }}
            className="d-flex justify-content-center mt-3"
          >
            {profile?.name || "-"}
          </Text>
        </Card>
        <Card nested={false}>
          <CardBody>
            <Text style={{ fontWeight: "bold" }}>{t("profile.contact")}</Text>
          </CardBody>
          <Separator />
          <CardBody>
            <ContactInfo
              alias={t("profile.contact.name")}
              avatar={<Avatar icon={Avatar.ICON.USER} />}
              text={profile?.contactName || "-"}
            />
          </CardBody>
          <Separator />
          <CardBody>
            <ContactInfo
              alias={t("profile.contact.phone")}
              avatar={<Avatar icon={Avatar.ICON.PHONE_MOBILE} />}
              text={
                profile?.contactPhone ? (
                  <PhoneNumber value={profile.contactPhone} />
                ) : (
                  "-"
                )
              }
            />
          </CardBody>
          <Separator />
          <CardBody>
            <ContactInfo
              alias={t("profile.contact.address")}
              avatar={<Avatar icon={Avatar.ICON.BUSINESS} />}
              text={
                profile?.clientAddress
                  ? getAddress([profile.clientAddress], "HEADQUARTERS")
                  : "-"
              }
            />
          </CardBody>
          <Separator />
          <CardBody>
            <ContactInfo
              alias={t("profile.contact.email")}
              avatar={<Avatar icon={Avatar.ICON.E_MAIL} />}
              text={profile?.contactEmail || "-"}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default Profile
